import {
    IServiceACATRequestDto,
    ListResult,
    ServiceACATRequestsGetByIdParams,
    ServiceACATRequestsPutByIdParams,
} from '@shared/api';
import { Api } from '../../Api';
import { IServiceACATRequestsDto } from './interfaces';
import { IServiceACATRequestsGetQuery } from './query';

export class ACATRequests {
    private static _basePath = '/acats';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${ACATRequests._basePath}`;
        return {
            async get(query: IServiceACATRequestsGetQuery) {
                const path = '/';
                return await Api.get<ListResult<IServiceACATRequestsDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getById({ id }: ServiceACATRequestsGetByIdParams) {
                const path = `/${id}`;
                return await Api.get<IServiceACATRequestDto>({
                    path: `${basePath}${path}`,
                });
            },
            async putAccept({ id, comment }: ServiceACATRequestsPutByIdParams) {
                const path = `/${id}/accept${comment ? '/?comment=' + comment : ''}`;
                return await Api.put<void>({
                    path: `${basePath}${path}`,
                });
            },
            async putReject({ id, comment }: ServiceACATRequestsPutByIdParams) {
                const path = `/${id}/reject${comment ? '/?comment=' + comment : ''}`;
                return await Api.put<void>({
                    path: `${basePath}${path}`,
                });
            },
            async putApprove({ id, comment }: ServiceACATRequestsPutByIdParams) {
                const path = `/${id}/approve${comment ? '/?comment=' + comment : ''}`;
                return await Api.put<void>({
                    path: `${basePath}${path}`,
                });
            },
        };
    }
}
